module.exports = __webpack_public_path__ + "img/qr svg.762909ac.svg";